import {EventEmitter, Injectable} from '@angular/core';
import {Document} from '../../../api/models/document';

@Injectable({
    providedIn: 'root'
})
export class CheckoutEventService {
    public openLocalDocumentEvent: EventEmitter<string> = new EventEmitter();
    public syncLocalDocumentEvent: EventEmitter<string> = new EventEmitter();
    public syncLocalDocumentResultEvent: EventEmitter<string> = new EventEmitter();
    public deleteFsFileEntryEvent: EventEmitter<string> = new EventEmitter();
    public deleteFsFileEntryResultEvent: EventEmitter<boolean> = new EventEmitter();
    public fetchAndGetCheckedOutFileContentEvent: EventEmitter<string> = new EventEmitter();
    public fetchAndGetCheckedOutFileContentResultEvent: EventEmitter<ArrayBuffer> = new EventEmitter();
    public deleteVaultDirectoryEvent: EventEmitter<string> = new EventEmitter();
    public deleteVaultDirectoryResultEvent: EventEmitter<boolean> = new EventEmitter();
    public downloadCheckedOutDocumentEvent: EventEmitter<Document> = new EventEmitter();
}
